'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trim;
function trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-select/lib/utils/trim.js
 ** module id = 1147
 ** module chunks = 3
 **/